import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {FormFieldOption} from './form-field-option.model';
import * as FormFieldOptionActions from './form-field-option.actions';

export const formFieldOptionsFeatureKey = 'formFieldOptions';

export interface State extends EntityState<FormFieldOption> {
  // additional entities state properties
}

export const adapter: EntityAdapter<FormFieldOption> = createEntityAdapter<FormFieldOption>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(FormFieldOptionActions.addFormFieldOption,
    (state, action) => adapter.addOne(action.formFieldOption, state)
  ),
  on(FormFieldOptionActions.upsertFormFieldOption,
    (state, action) => adapter.upsertOne(action.formFieldOption, state)
  ),
  on(FormFieldOptionActions.addFormFieldOptions,
    (state, action) => adapter.addMany(action.formFieldOptions, state)
  ),
  on(FormFieldOptionActions.upsertFormFieldOptions,
    (state, action) => adapter.upsertMany(action.formFieldOptions, state)
  ),
  on(FormFieldOptionActions.updateFormFieldOption,
    (state, action) => adapter.updateOne(action.formFieldOption, state)
  ),
  on(FormFieldOptionActions.updateFormFieldOptions,
    (state, action) => adapter.updateMany(action.formFieldOptions, state)
  ),
  on(FormFieldOptionActions.deleteFormFieldOption,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(FormFieldOptionActions.deleteFormFieldOptions,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(FormFieldOptionActions.loadFormFieldOptions,
    (state, action) => adapter.setAll(action.formFieldOptions, state)
  ),
  on(FormFieldOptionActions.clearFormFieldOptions,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
